import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _53855f7d = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _d275e0ea = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _311d448b = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _5c49c320 = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _38521d1c = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _747cefca = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _59404627 = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _39f70ad5 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _1bea45ed = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _61e2653a = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _6ff12c98 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _7314e718 = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _e292b47a = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _6e953e9a = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _089adce5 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _5a56fe20 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _3d2f4d8a = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _d9470cf6 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _53855f7d,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _d275e0ea,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _311d448b,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _5c49c320,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _38521d1c,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _747cefca,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _747cefca,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _747cefca,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _59404627,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _39f70ad5,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _1bea45ed,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _39f70ad5,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _1bea45ed,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _61e2653a,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _61e2653a,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _61e2653a,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _61e2653a,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _61e2653a,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _61e2653a,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _61e2653a,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _6ff12c98,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _6ff12c98,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _7314e718,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _e292b47a,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _e292b47a,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _6e953e9a,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _089adce5,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _5a56fe20,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _5a56fe20,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _3d2f4d8a,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _d9470cf6,
    name: "appDownload"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
